import { Component, OnInit, OnDestroy } from "@angular/core";
import { BroshService } from "../shared/services/brosh.service";
import { AuthService } from "../shared/services/auth.service";
import { RouteEnum } from "../shared/models/routes.model";
import { Router } from "@angular/router";
import { DashboardData } from "../shared/models/dashboard.model";
import { Store } from "@ngrx/store";
import { dashboardData } from "../shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { REQUEST_DASHBOARD_REFRESH } from "../shared/ngrx/ngrx-actions";
import { LoaderComponent } from "../shared/components/ui/loader/loader.component";
import { DashOrderSummaryComponent } from "./dash-order-summary/dash-order-summary.component";
import { DashSupplySummaryLabComponent } from "./dash-supply-summary-lab/dash-supply-summary-lab.component";
import { DashSupplyStatusComponent } from "./dash-supply-status/dash-supply-status.component";
import { DashDeliveryStatusComponent } from "./dash-delivery-status/dash-delivery-status.component";
import { DashNewsComponent } from "./dash-news/dash-news.component";
import { DashInvoicesSummaryComponent } from "./dash-invoices-summary/dash-invoices-summary.component";
import { DashChatSummaryComponent } from "./dash-chat-summary/dash-chat-summary.component";
import { DashTasksComponent } from "./dash-tasks/dash-tasks.component";
import { DashBannersComponent } from "./dash-banners/dash-banners.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  standalone: true,
  imports: [
    LoaderComponent,
    DashOrderSummaryComponent,
    DashSupplySummaryLabComponent,
    DashSupplyStatusComponent,
    DashDeliveryStatusComponent,
    DashNewsComponent,
    DashInvoicesSummaryComponent,
    DashChatSummaryComponent,
    DashTasksComponent,
    DashNewsComponent,
    DashBannersComponent,
    CommonModule,
  ],
})
export class DashboardComponent implements OnInit, OnDestroy {
  displayInvoices: boolean;
  displayLabSupplyOrdersSummary: boolean;
  displayClinicSupplySummary: boolean;
  displayNews: boolean;
  displayBanners: boolean;
  displayLastOrdersSummary: boolean;
  displayTasks: boolean;
  refreshTimer: any;
  refreshDashboardIntervalSeconds: number = 60 * 1;
  destroy$ = new Subject();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  get clinicUserSw(): boolean {
    return this.authService.currentUser.isClinicUser;
  }

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private authService: AuthService,
    private router: Router,
    private actions$: Actions
  ) {
    this.displayLastOrdersSummary =
      this.authService.currentUser.authDetails.getBooleanValue(
        "DASHBOARD.ORDERS_SUMMARY_VISIBLE_SW"
      );
    this.displayInvoices =
      this.authService.currentUser.authDetails.getBooleanValue(
        "INVOICES.VIEW_INVOICES_SW"
      ) && this.authService.currentUser.org == "CLINIC";
    this.displayLabSupplyOrdersSummary =
      this.authService.currentUser.org == "LAB";
    this.displayClinicSupplySummary =
      this.authService.currentUser.org == "CLINIC";
    this.displayNews = this.authService.currentUser.org != "PLANT";
    this.displayBanners = this.authService.currentUser.org != "PLANT";
    this.displayTasks =
      this.authService.currentUser.authDetails.getBooleanValue(
        "ORDERS.CHAT_TASKS_SW"
      );
  }

  ngOnInit(): void {
    this.getData();
    this.scheduleGetData();

    this.actions$
      .pipe(
        ofType(REQUEST_DASHBOARD_REFRESH),
        takeUntil(this.destroy$),
        map(({}) => {
          this.scheduleGetData();
          this.getData();
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.clearTimer();
    this.destroy$.next(1);
  }

  scheduleGetData() {
    this.clearTimer();

    this.refreshTimer = setInterval(() => {
      this.getData(true);
    }, this.refreshDashboardIntervalSeconds * 1000);
  }

  clearTimer() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  getData(timer: boolean = false) {
    this.broshService.getDashboardData(timer).subscribe();
  }
}
